import React from 'react';
import useStyle from './tableInfoLegendary.style';
import { SubTitle } from 'components/atoms/Texts/SubTitle';

export interface TableMyResultLegendaryProps {
  subTitle?: string;
  legends: string[];
  highlightLast?: boolean;
}

export const TableInfoLegendary = ({
  subTitle,
  legends,
  highlightLast = false
}: TableMyResultLegendaryProps) => {
  const classes = useStyle({ highlightLast });

  return (
    <div className={classes.root}>
      {subTitle && <SubTitle text={subTitle} />}
      <div className={classes.legendary}>
        {legends.map((legend, i) => (
          <span key={i}>{legend}</span>
        ))}
      </div>
    </div>
  );
};
